import React from 'react';
import DisplayComponent from './DisplayComponent';
import BillingContent from '../components/BillingContent';

const BillingPage = () => {
  return (
    <DisplayComponent title="Billing">
      <BillingContent />
    </DisplayComponent>
  );
};


export default BillingPage;
